import { Circle, Text, Tooltip } from '@chakra-ui/react';

import { getInitials } from 'app/utils/strings';

import { CircleWithInitialsProps } from './types';

function CircleWithInitials({ bgColor, size, color, textStyle, text }: CircleWithInitialsProps) {
  return (
    <Tooltip hasArrow shouldWrapChildren arrowPadding={0} placement="top" label={text}>
      <Circle bgColor={bgColor} size={size} cursor="pointer">
        <Text color={color} textStyle={textStyle}>
          {getInitials(text)}
        </Text>
      </Circle>
    </Tooltip>
  );
}

export default CircleWithInitials;
